export default {
    title: 'Nueva Autorización',
    type: 'Tipo de autorización',
    typeSubtitle: 'Seleccione un tipo de autorización para continuar:',
    footerTitle: 'Seleccione un tipo de autorización para poder continuar',
    backBtn: 'Cancelar',
    continueBtn: 'Continuar',
    medicalTypes : {
        subHeader: 'MÉDICAS',
        medicines: 'Medicamentos',
        diagnostic: 'Éxamenes por imagen',
        laboratories: 'Laboratorios',
        outpatientCare: 'Consulta',
        process: 'Procedimiento',
        generic: 'Generico'
    },
    navBar: {
        medicines: '(Medicamentos)',
        diagnostic: '(Éxamenes por imagen)',
        laboratories: '(Laboratorios)',
        outpatientCare: '(Consulta médica)',
        process: '(Procedimiento)'
    }
}